import { Component, OnInit } from '@angular/core';
import {UserAccount} from '../../shared/api/model/user-account';
import {AccountService} from '../../shared/api/resources/account/account.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {UserDetailsComponent} from '../../shared/atoms/user-details/user-details.component';

@Component({
  selector: 'app-accounts',
  templateUrl: './accounts.component.html',
  styleUrls: ['./accounts.component.scss']
})
export class AccountsComponent implements OnInit {
  userAccounts: UserAccount[];
  accountsLoaded = false;

  constructor(private _accountService: AccountService, private _modalService: NgbModal) { }

  ngOnInit() {
    this.updateAccounts();
  }

  openUserAccountModal(userAccount?: UserAccount) {
    const modalRef = this._modalService.open(UserDetailsComponent, {size: 'sm'});
    modalRef.componentInstance.userAccount = userAccount ? Object.assign(Object.create(userAccount), userAccount) : undefined;
    modalRef.result.then(
      () => {
        this.updateAccounts();
      }
    ).catch(() => {});
  }

  updateAccounts() {
    this.accountsLoaded = false;
    this._accountService.getAgentList().subscribe(
      (userAccounts: UserAccount[]) => {
        this.userAccounts = userAccounts;
      },
      undefined,
      () => {
        this.accountsLoaded = true;
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/manage/accounts/accounts.component.ts